export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      solution: "Solution",
      about: "À propos",
    },
    hero: {
      systemActive: "Système Actif",
      systemSleep: "Système En veille",
      title1: "Contrôlez votre",
      light: "lumière",
      title2: "Économisez votre",
      energy: "énergie",
      description: "Un filtre intelligent qui s'ajuste automatiquement au soleil pour réduire la chaleur, améliorer votre confort et alléger vos factures — sans aucun effort.",
      buyButton: "Acheter mon filtre",
      demoButton: "Voir la démo"
    },
    cart: {
      title: "Votre Panier",
      emptyTitle: "Votre panier est vide",
      emptyDesc: "Configurez votre filtre idéal dès maintenant.",
      goToShop: "Aller à la boutique",
      summary: "Résumé",
      subtotal: "Sous-total",
      tps: "TPS (5%)",
      tvq: "TVQ (9.975%)",
      total: "Total",
      checkout: "Paiement",
      width: "L:",
      height: "H:",
      depth: "P:",
      quantity: "Quantité",
      remove: "Supprimer"
    },
    shop: {
      new: "Nouveau",
      createFilter: "Créez votre filtre",
      custom: "sur mesure",
      description: "Chaque fenêtre est unique. Utilisez notre configurateur interactif pour concevoir la protection solaire parfaite pour votre intérieur.",
      startConfigurator: "Lancer le configurateur",
      step1Title: "Dimensions",
      step1Desc: "Saisissez les mesures exactes de vos fenêtres.",
      step2Title: "Modèle",
      step2Desc: "Choisissez la technologie adaptée à vos besoins.",
      step3Title: "Design",
      step3Desc: "Personnalisez les finitions pour votre intérieur.",
      compatible: "modèle(s) compatible(s)",
      noCompatible: "Aucun modèle compatible",
      dimensions: "Dimensions",
      width: "Largeur",
      height: "Hauteur",
      depth: "Profondeur",
      dimensionsDesc: "Ajustez les mesures pour trouver le filtre parfait."
    },
    configurator: {
      headerTitle: "Configurateur",
      typeTitle: "Que souhaitez-vous configurer ?",
      typeDesc: "Sélectionnez le type de produit à ajouter.",
      filterTitle: "Filtre Intelligent",
      filterDesc: "Protection solaire sur mesure pour vos fenêtres.",
      configure: "Configurer",
      hubTitle: "Hub de Contrôle",
      hubDesc: "Le cerveau pour piloter vos filtres connectés.",
      dimensionsTitle: "Dimensions",
      dimensionsDesc: "Définissez la taille de votre protection solaire.",
      width: "Largeur",
      height: "Hauteur",
      depth: "Profondeur du cadre",
      modelTitle: "Modèle",
      modelDesc: "Choisissez la performance adaptée à vos besoins.",
      estimatedPrice: "Prix estimé",
      controlTitle: "Contrôle",
      controlDesc: "Sélectionnez votre Hub de contrôle.",
      price: "Prix",
      included: "Inclus",
      designTitle: "Design",
      designDesc: "Une finition qui s'intègre à votre intérieur.",
      recapTitle: "Récapitulatif",
      recapDesc: "Vérifiez votre configuration.",
      selectedModel: "Modèle sélectionné",
      depthLabel: "Profondeur",
      quantity: "Quantité",
      total: "Total",
      successTitle: "C'est dans la boîte !",
      successDesc: "Votre configuration a été ajoutée au panier avec succès.",
      configureAnother: "Configurer un autre",
      viewCart: "Voir le panier",
      back: "Retour",
      next: "Suivant",
      addToCart: "Ajouter au panier",
      steps: {
        type: "Type",
        dimensions: "Dimensions",
        model: "Modèle",
        design: "Design",
        recap: "Récapitulatif",
        control: "Contrôle"
      },
      colors: {
        anthracite: "Gris Anthracite",
        silver: "Aluminium Brossé",
        black: "Noir Mat",
        white: "Blanc Pur"
      },
      models: {
        essential: "Essentiel",
        essentialDesc: "Protection efficace pour le quotidien.",
        standard: "Standard",
        standardDesc: "Le parfait équilibre entre confort et protection.",
        performance: "Performance",
        performanceDesc: "Isolation thermique et confort visuel optimal."
      },
      controls: {
        hub: "Hub SAILEC",
        hubDesc: "Le cerveau de votre installation.",
        none: "Aucun",
        noneDesc: "Je possède déjà un Hub pour cette pièce."
      }
    },
    problem: {
    title: "Votre maison lutte contre le climat ?",
    subtitle: "Les solutions actuelles sont soit inefficaces, soit trop complexes.",
    card1Title: "Surchauffe en été",
    card1Text: "Vos pièces deviennent des saunas. La climatisation tourne à fond, gonflant vos factures.",
    card2Title: "Gestion Manuelle",
    card2Text: "Ouvrir, fermer, ouvrir... Vous passez votre temps à ajuster des stores pour votre confort sans grands résultats.",
    card3Title: "Gaspillage en hiver",
    card3Text: "Arrêter de chauffer l'extérieur et conserver votre énergie où ça compte vraiment, dans votre maison.",
    statsTitle: "Les chiffres parlent d'eux-mêmes",
    stat1Value: "54%",
    stat1Label: "de la facture d'électricité",
    stat1Desc: "provient du chauffage et de la climatisation pour un consommateur moyen",
    stat2Value: "15%",
    stat2Label: "des pertes thermiques",
    stat2Desc: "d'un bâtiment sont directement liées aux fenêtres"
    },
    solution: {
      title: "Le filtre qui s'adapte à vos besoins",
      step1Title: "Analyse",
      step1Text: "Capteurs, IA et données météo en temps réel.",
      step2Title: "Ajustement",
      step2Text: "Ajustement optimisé du filtre solaire.",
      step3Title: "Résultat",
      step3Text: "Confort thermique et économies passives."
    },
    filterDemo: {
      title: "Démonstration Interactive du Filtre",
      subtitle: "Visualisez en temps réel comment notre technologie fonctionne selon les saisons",
      exterior: "EXTÉRIEUR",
      interior: "INTÉRIEUR",
      sun: "Soleil",
      heat: "Chaleur",
      deployment: "Déploiement du Filtre",
      open: "Ouvert",
      partial: "Partiel",
      closed: "Fermé",
      active: "ACTIF",
      inactive: "INACTIF",
      summerMode: "Mode Été",
      winterMode: "Mode Hiver",
      summerDesc: "Les rayons UV du soleil sont réfléchis vers l'extérieur",
      winterDesc: "Les rayons infrarouges sont réfléchis vers l'intérieur",
      uvRays: "Rayons UV",
      irRays: "Rayons IR",
      blocked: "réfléchis",
      summerActiveMessage: "Mode Été • {percent}% des UV réfléchis vers l'extérieur",
      winterActiveMessage: "Mode Hiver • {percent}% des IR conservés à l'intérieur",
      inactiveMessage: "Système en veille • Activez pour profiter de la protection intelligente"
    },
    product: {
      badge: "HARDWARE INTELLIGENT",
      title1: "Invisible quand il faut.",
      title2: "Protecteur quand il le faut.",
      description: "Alliez performance et transparence. Nos films solaires haute technologie bloquent les rayons UV et conservent votre chaleur, tout en préservant la lumière naturelle.",
      techSpecs: "Voir les spécifications techniques"
    },
    app: {
      title: "Pilotez la lumière, tout simplement.",
      description: "Grâce à l'application SAILECtech, transformez vos économies en victoires. Atteignez vos objectifs et voyez l'impact réel de votre confort sur la planète et votre porte feuille.",
      dashboard: "Dashboard",
      june: "Juin",
      realTime: "Temps Réel",
      performance: "PERFORMANCE",
      vsYesterday: "vs Hier",
      feature1Title: "Set & Forget",
      feature1Desc: "Une fois configuré, vous n'aurez plus jamais à y toucher.",
      feature2Title: "Dashboard",
      feature2Desc: "Quantifiez vos économies, visualisez leur impact.",
      feature3Title: "Simple et Intuitif",
      feature3Desc: "Une expérience utilisateur réfléchie pour vos besoins."
    },
    howItWorks: {
      title: "Simplissime. Du début à la fin.",
      step1Title: "Commandez",
      step1Text: "Sélectionnez le filtre adapté pour vos besoins.",
      step2Title: "Installez",
      step2Text: "Recevez votre kit sur mesure. Pose rapide, sans outil.",
      step3Title: "Économisez",
      step3Text: "Regardez vos factures diminuer à partir de l'application SAILECtech!"
    },
    cta: {
      title: "Prêt à reprendre le contrôle ?",
      subtitle: "Rejoignez les maisons intelligentes. Estimez vos économies en moins de 5 minutes à partir de l'application SAILECtech.",
      button: "Acheter mon filtre maintenant",
      secondaryButton: "Découvrir notre solution"
    },
    footer: {
      filters: "Filtres",
      technology: "Technologie",
      support: "Support",
      pro: "Équipe",
      copyright: "© 2025 SAILECtech. Innovation Durable."
    },
    shop: {
      title: "Nos Filtres Intelligents",
      subtitle: "Trouvez le filtre parfait pour vos fenêtres",
      backHome: "Retour à l\'accueil",
      dimensions: "Dimensions",
      dimensionsDesc: "Ajustez les dimensions de votre fenêtre pour trouver les modèles compatibles",
      width: "Largeur",
      height: "Hauteur",
      depth: "Profondeur",
      compatible: "modèle(s) compatible(s)",
      noCompatible: "Aucun modèle compatible",
      recommended: "RECOMMANDÉ",
      notCompatible: "NON COMPATIBLE",
      addToCart: "Ajouter au panier",
      incompatible: "Incompatible",
      noModelsFound: "Aucun modèle trouvé",
      adjustDimensions: "Essayez d\'ajuster les dimensions pour voir plus de modèles compatibles"
    },
    about: {
      title: "À Propos",
      subtitle: "Découvrez l'équipe et les valeurs derrière SAILECtech",
      backHome: "Retour à l'accueil",
      // Header section
      headerBadge: "Identité & Vision",
      headerTitle1: "De l'idée",
      headerTitle2: "à l'Impact.",
      headerSubtitle: "Derrière la technologie, il y a une équipe passionnée. Nous combinons innovation technique et design intuitif pour repenser notre façon de consommer l'énergie.",
      // Mission section
      missionBadge: "INITIALISATION DU PROTOCOLE : MISSION",
      missionTitle1: "L'intelligence énergétique,",
      missionTitle2: "enfin simplifiée.",
      missionDescription: "Ce qui a commencé comme un défi d'ingénierie entre six étudiants passionnés est devenu notre mission : une solution pensée par des ingénieurs, conçue pour l'humain.",
      // Values section
      valuesTitle: "Nos Piliers Fondamentaux",
      value1Title: "Simplicité",
      value1Desc: "La technologie la plus avancée est celle qui se fait oublier. Nous transformons la complexité thermique en une expérience fluide, intuitive et sans friction. De l'installation à l'utilisation quotidienne, tout est pensé pour vous simplifier la vie.",
      value2Title: "Impact",
      value2Desc: "Plus qu'un produit, un effet de levier. Nous visons un triple retour sur investissement : confort immédiat pour l'humain, économies réelles pour le portefeuille et réduction durable de l'empreinte carbone pour la société.",
      value3Title: "Ingéniosité",
      value3Desc: "L'art de la solution élégante. Nous utilisons notre créativité technique pour contourner la complexité. Là où d'autres voient des contraintes, nous voyons des opportunités de créer des systèmes plus légers, plus malins et plus performants.",
      // Timeline section
      timelineTitle: "Notre histoire",
      timeline1Year: "Été 2025",
      timeline1Title: "L'Étincelle",
      timeline1Desc: "Six étudiants, un constat frappant : nos fenêtres sont les maillons faibles de l'efficacité énergétique. L'objectif naît : dompter le soleil pour allier confort et économie, dans le cadre du défi CQI.",
      timeline2Year: "Automne 2025",
      timeline2Title: "De l'Idée au Prototype",
      timeline2Desc: "Des nuits blanches, du bois de construction et une première victoire: notre prototype. La preuve est là : la technologie fonctionne. L'intelligence thermique devient réalité.",
      timeline3Year: "Hiver 2026 - Aujourd'hui",
      timeline3Title: "La compétition CQI",
      timeline3Desc: "Plus qu'une étape académique, le défi 'Conception Innovatrice' marque notre pivot. Nous ne présentons plus seulement un projet étudiant, mais une vision d'entreprise prête à avoir un réel impact.",
      timeline4Year: "Été 2026",
      timeline4Title: "Vers l'Impact Réel",
      timeline4Desc: "Nous finalisons le design et le produit, nous préparons le déploiement. Notre mission commence véritablement : mesurer l'impact de notre solution dans des foyers.",
      // Team section
      teamTitle: "L'Équipe Derrière la Vision",
      teamSubtitle: "Six talents complémentaires unis par une même ambition : rendre l'efficacité énergétique accessible à tous.",
      // Social section
      socialTitle: "Rejoignez le mouvement."
    },
    solutionPage: {
      // Intro Section
      introTitle1: "Une Synergie",
      introTitle2: "Parfaite",
      introSubtitle: "Notre stratégie repose sur trois piliers interconnectés. Un hardware innovant, piloté par une app intuitive, optimisé par une science de pointe.",
      nodeApi: "L'API",
      nodeApiSub: "Cerveau Scientifique",
      nodeApp: "L'App",
      nodeAppSub: "Contrôle Intuitif",
      nodeFilter: "Le Filtre",
      nodeFilterSub: "Action Physique",
      // Filter Section
      filterBadge: "Composante 01",
      filterTitle1: "Le Bouclier Thermique",
      filterTitle2: "Reversible & Non-Permanent",
      filterDesc: "Une prouesse d'ingénierie qui utilise la tension mécanique plutôt que la colle. Installez, retournez ou retirez votre filtre en quelques secondes, sans aucun outil ni dégât.",
      statUV: "Rayons UV Bloqués",
      statIR: "Infrarouges Rejetés",
      statInstall: "Temps d'Installation",
      reverseTitle: "Technologie \"Reverse\"",
      reverseDesc: "Les films classiques sont un compromis : ils rejettent la chaleur en été mais aussi en hiver. Notre solution innove :",
      reverseSummer: "Face A (Été) : Rejet thermique maximal",
      reverseWinter: "Face B (Hiver) : Conservation de chaleur",
      transparencyTitle: "Transparence Cristalline",
      transparencyDesc: "Pourquoi vivre dans le noir pour rester au frais ? Contrairement aux stores qui obstruent la vue, notre filtre préserve la connexion avec l'extérieur.",
      visibility: "Visibilité",
      comparisonTitle: "Le Match Comparatif",
      comparisonSubtitle: "Une supériorité technique évidente sur tous les points.",
      critere: "Critère",
      sailectech: "SAILECtech",
      colStore: "Stores",          
      colFilm: "Film",              
      colWindow: "Fenêtre Smart",   
      compInstallation: "Installation",
      compInstallSailec: "5 min (Clips)",
      compInstallStore: "Manuel / Complexe",      
      compInstallFilm: "Permanent (Colle)",       
      compInstallWindow: "Rénovation majeure",  
      compSeason: "Saisonnalité",
      compSeasonSailec: "Adaptable (Mode Été/Hiver)",
      compSeasonStore: "Fixe",                    
      compSeasonFilm: "Fixe (Perte hiver)",       
      compSeasonWindow: "Adaptable",             
      compCost: "Coût",
      compCostSailec: "Abordable & ROI Rapide",
      compCostStore: "Faible",                   
      compCostFilm: "Moyen",                    
      compCostWindow: "Extrême ($$$)",            
      compHeat: "Gestion Chaleur",
      compHeatSailec: "Rejet Extérieur",
      compHeatStore: "Absorption Intérieure",    
      compHeatFilm: "Rejet partiel",             
      compHeatWindow: "Rejet efficace",           
      compVisibility: "Visibilité",
      compVisibilitySailec: "Claire & Préservée",
      compVisibilityStore: "Obstruée",            
      compVisibilityFilm: "Teinte permanente", 
      compVisibilityWindow: "Teinte variable",   
      // App Section
      appBadge: "Composante 02",
      appTitle: "Le Centre de Commande",
      appComingSoon: "Bientôt disponible sur App Store & Play Store",
      onboardingTitle: "1. Onboarding Ultra-Rapide",
      step: "Étape",
      config: "Configuration",
      step1Desc: "Analyse du potentiel solaire local.",
      step2Desc: "Digitalisation de votre espace.",
      step3Desc: "Création du modèle thermique.",
      step4Desc: "Vérification de l'agencement.",
      step5Desc: "Vos gains énergétiques estimés.",
      dashboardTitle: "2. Mettez votre Impact de l'avant",
      dashboardDesc: "Visualisez vos économies en temps réel. Voyez votre impact de la manière qui compte le plus pour vous. Un interface conçu pour être compris en un coup d'œil. ",
      dashboardMain: "Dashboard Principal",
      dashboardSub: "Économies & KPI",
      zoneTitle: "3. Contrôle par Pièce",
      zoneDesc: "Une vue en plan de votre domicile permet de gérer chaque pièce individuellement. Chambre trop chaude ? Réglez-la sans bouger du salon.",
      zonePlan: "Vue Plan",
      zoneSub: "Gestion par Pièce",
      // API Section
      apiBadge: "Composante 03",
      apiTitle: "L'Intelligence Invisible",
      apiDesc: "C'est notre point différenciateur majeur. Là où d'autres systèmes sont de simples \"on/off\", notre API utilise un modèle thermique propriétaire.",
      apiInputTitle: "Données Entrantes",
      apiInputDesc: "L'API ingère en temps réel la météo locale, l'orientation de vos fenêtres et vos préférences de température.",
      apiCalcTitle: "Le Calcul",
      apiCalcDesc: "Notre algorithme détermine la position exacte du filtre pour maximiser la lumière naturelle tout en bloquant l'apport thermique excessif.",
      apiAutoTitle: "L'Automatisation",
      apiAutoDesc: "L'ordre est envoyé au hardware sans que vous ayez à intervenir. C'est le véritable confort : ne plus avoir à y penser.",
      // Recap Section
      recapTitle: "Pourquoi ça change tout ?",
      recap1Num: "01. App",
      recap1Title: "Expérience Utilisateur",
      recap1Desc: "La facilité d'utilisation. On enlève la friction technologique pour ne garder que le contrôle.",
      recap2Num: "02. API",
      recap2Title: "Rigueur Scientifique",
      recap2Desc: "L'optimisation continue. Un système qui devient plus intelligent avec le temps et les données.",
      recap3Num: "03. Filtre",
      recap3Title: "Résultat Réel",
      recap3Desc: "L'efficacité physique. Des économies tangibles sur la facture et un confort ressenti immédiat."
    },
    waitlist: {
      title: "Rejoignez la Liste d\'Attente",
      subtitle: "Nos filtres intelligents arrivent bientôt !",
      description: "Nous finalisons actuellement le développement de nos filtres intelligents. Inscrivez-vous pour être parmi les premiers informés du lancement et bénéficier d'une offre exclusive.",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone (optionnel)",
      windowSize: "Taille de fenêtre souhaitée",
      small: "Petite (60-100 cm)",
      medium: "Moyenne (100-150 cm)",
      large: "Grande (150-220 cm)",
      xlarge: "Très grande (220+ cm)",
      submitButton: "Rejoindre la liste d\"attente",
      successTitle: "Inscription réussie !",
      successMessage: "Merci de votre intérêt. Nous vous contacterons dès le lancement.",
      benefits: "Avantages exclusifs",
      benefit1: "Accès prioritaire au lancement",
      benefit2: "Remise de 15% pour les premiers inscrits",
      limitedSpots: "Places limitées - Inscrivez-vous maintenant !",
      submitting: "Inscription en cours..."
    }
  },
  en: {
    nav: {
      home: "Home",
      solution: "Solution",
      about: "About",
    },
    hero: {
      systemActive: "System Active",
      systemSleep: "Sleep Mode",
      title1: "Smart",
      light: "light",
      title2: "for energy",
      energy: "savings",
      description: "An autonomous solution that adapts to your environment to optimize comfort and reduce consumption.",
      buyButton: "Buy Filter",
      demoButton: "See Demo"
    },
    cart: {
      title: "Your Cart",
      emptyTitle: "Your cart is empty",
      emptyDesc: "Configure your ideal filter now.",
      goToShop: "Go to Shop",
      summary: "Summary",
      subtotal: "Subtotal",
      tps: "GST (5%)",
      tvq: "QST (9.975%)",
      total: "Total",
      checkout: "Checkout",
      width: "W:",
      height: "H:",
      depth: "D:",
      quantity: "Quantity",
      remove: "Remove"
    },
    shop: {
      new: "New",
      createFilter: "Create your filter",
      custom: "custom-made",
      description: "Each window is unique. Use our interactive configurator to design the perfect sun protection for your interior.",
      startConfigurator: "Start Configurator",
      step1Title: "Dimensions",
      step1Desc: "Enter the exact measurements of your windows.",
      step2Title: "Model",
      step2Desc: "Choose the technology adapted to your needs.",
      step3Title: "Design",
      step3Desc: "Customize the finishes for your interior.",
      compatible: "compatible model(s)",
      noCompatible: "No compatible model",
      dimensions: "Dimensions",
      width: "Width",
      height: "Height",
      depth: "Depth",
      dimensionsDesc: "Adjust measurements to find the perfect filter."
    },
    configurator: {
      headerTitle: "Configurator",
      typeTitle: "What do you want to configure?",
      typeDesc: "Select the type of product to add.",
      filterTitle: "Smart Filter",
      filterDesc: "Custom sun protection for your windows.",
      configure: "Configure",
      hubTitle: "Control Hub",
      hubDesc: "The brain to control your connected filters.",
      dimensionsTitle: "Dimensions",
      dimensionsDesc: "Define the size of your sun protection.",
      width: "Width",
      height: "Height",
      depth: "Frame Depth",
      modelTitle: "Model",
      modelDesc: "Choose the performance adapted to your needs.",
      estimatedPrice: "Estimated Price",
      controlTitle: "Control",
      controlDesc: "Select your Control Hub.",
      price: "Price",
      included: "Included",
      designTitle: "Design",
      designDesc: "A finish that fits your interior.",
      recapTitle: "Summary",
      recapDesc: "Verify your configuration.",
      selectedModel: "Selected Model",
      depthLabel: "Depth",
      quantity: "Quantity",
      total: "Total",
      successTitle: "It's in the bag!",
      successDesc: "Your configuration has been successfully added to the cart.",
      configureAnother: "Configure another",
      viewCart: "View Cart",
      back: "Back",
      next: "Next",
      addToCart: "Add to Cart",
      steps: {
        type: "Type",
        dimensions: "Dimensions",
        model: "Model",
        design: "Design",
        recap: "Summary",
        control: "Control"
      },
      colors: {
        anthracite: "Anthracite Grey",
        silver: "Brushed Aluminum",
        black: "Matte Black",
        white: "Pure White"
      },
      models: {
        essential: "Essential",
        essentialDesc: "Effective protection for daily use.",
        standard: "Standard",
        standardDesc: "The perfect balance between comfort and protection.",
        performance: "Performance",
        performanceDesc: "Optimal thermal insulation and visual comfort."
      },
      controls: {
        hub: "SAILEC Hub",
        hubDesc: "The brain of your installation.",
        none: "None",
        noneDesc: "I already have a Hub for this room."
      }
    },
    problem: {
      title: "Is your home fighting the climate?",
      subtitle: "Current solutions are either ineffective or too complex.",
      card1Title: "Summer Overheating",
      card1Text: "Your rooms turn into saunas. AC runs at full blast, bloating your bills.",
      card2Title: "Manual Management",
      card2Text: "Open, close, open... You spend your time adjusting blinds for comfort with little result.",
      card3Title: "Winter Waste",
      card3Text: "Stop heating the outdoors and keep your energy where it counts—inside your home.",
      statsTitle: "The numbers speak for themselves",
      stat1Value: "54%",
      stat1Label: "of electricity bills",
      stat1Desc: "come from heating and cooling for the average consumer",
      stat2Value: "15%",
      stat2Label: "of thermal losses",
      stat2Desc: "in a building are directly linked to windows"
    },
    solution: {
      title: "The filter that adapts to your needs",
      step1Title: "Analysis",
      step1Text: "Sensors, AI, and real-time weather data.",
      step2Title: "Adjustment",
      step2Text: "Optimized solar filter adjustment.",
      step3Title: "Result",
      step3Text: "Thermal comfort and passive savings."
    },
    filterDemo: {
      title: "Interactive Filter Demo",
      subtitle: "Visualize in real-time how our technology works across seasons",
      exterior: "EXTERIOR",
      interior: "INTERIOR",
      sun: "Sun",
      heat: "Heat",
      deployment: "Filter Deployment",
      open: "Open",
      partial: "Partial",
      closed: "Closed",
      active: "ACTIVE",
      inactive: "INACTIVE",
      summerMode: "Summer Mode",
      winterMode: "Winter Mode",
      summerDesc: "UV rays from the sun are reflected outwards",
      winterDesc: "Infrared rays are reflected inwards",
      uvRays: "UV Rays",
      irRays: "IR Rays",
      blocked: "reflected",
      summerActiveMessage: "Summer Mode • {percent}% of UV reflected outwards",
      winterActiveMessage: "Winter Mode • {percent}% of IR kept inside",
      inactiveMessage: "System idle • Activate to enjoy smart protection"
    },
    product: {
      badge: "SMART HARDWARE",
      title1: "Invisible when needed.",
      title2: "Protective when it counts.",
      description: "Combine performance and transparency. Our high-tech solar films block UV rays and retain heat, all while preserving natural light.",
      techSpecs: "View technical specifications"
    },
    app: {
      title: "Master the light, simply.",
      description: "With the SAILECtech app, turn your savings into victories. Reach your goals and see the real impact of your comfort on the planet and your wallet.",
      dashboard: "Dashboard",
      june: "June",
      realTime: "Real Time",
      performance: "PERFORMANCE",
      vsYesterday: "vs Yesterday",
      feature1Title: "Set & Forget",
      feature1Desc: "Once configured, you'll never have to touch it again.",
      feature2Title: "Dashboard",
      feature2Desc: "Quantify your savings, visualize their impact.",
      feature3Title: "Simple and Intuitive",
      feature3Desc: "A user experience thoughtfully designed for your needs."
    },
    howItWorks: {
      title: "Simple. From start to finish.",
      step1Title: "Order",
      step1Text: "Select the filter adapted to your needs.",
      step2Title: "Install",
      step2Text: "Receive your custom kit. Quick installation, tool-free.",
      step3Title: "Save",
      step3Text: "Watch your bills decrease right from the SAILECtech app!"
    },
    cta: {
      title: "Ready to take back control?",
      subtitle: "Join the smart home movement. Estimate your savings in less than 5 minutes via the SAILECtech app.",
      button: "Buy my filter now",
      secondaryButton: "Discover our solution"
    },
    footer: {
      filters: "Filters",
      technology: "Technology",
      support: "Support",
      pro: "Team",
      copyright: "© 2025 SAILECtech. Sustainable Innovation."
    },
    shop: {
      title: "Our Smart Filters",
      subtitle: "Find the perfect filter for your windows",
      backHome: "Back to home",
      dimensions: "Dimensions",
      dimensionsDesc: "Adjust your window dimensions to find compatible models",
      width: "Width",
      height: "Height",
      depth: "Depth",
      compatible: "compatible model(s)",
      noCompatible: "No compatible models",
      recommended: "RECOMMENDED",
      notCompatible: "NOT COMPATIBLE",
      addToCart: "Add to cart",
      incompatible: "Incompatible",
      noModelsFound: "No models found",
      adjustDimensions: "Try adjusting dimensions to see more compatible models"
    },
    about: {
      title: "About Us",
      subtitle: "Discover the team and values behind SAILECtech",
      backHome: "Back to home",
      // Header section
      headerBadge: "Identity & Vision",
      headerTitle1: "From Idea",
      headerTitle2: "to Impact.",
      headerSubtitle: "Behind the technology lies a passionate team. We combine technical innovation and intuitive design to rethink how we consume energy.",
      // Mission section
      missionBadge: "PROTOCOL INITIALIZATION: MISSION",
      missionTitle1: "Energy intelligence,",
      missionTitle2: "finally simplified.",
      missionDescription: "What started as an engineering challenge between six passionate students became our mission: a solution thought out by engineers, designed for humans.",
      // Values section
      valuesTitle: "Our Fundamental Pillars",
      value1Title: "Simplicity",
      value1Desc: "The most advanced technology is the one you forget is there. We transform thermal complexity into a fluid, intuitive, and frictionless experience. From installation to daily use, everything is designed to simplify your life.",
      value2Title: "Impact",
      value2Desc: "More than a product, a leverage effect. We aim for a triple return on investment: immediate comfort for humans, real savings for the wallet, and sustainable carbon footprint reduction for society.",
      value3Title: "Ingenuity",
      value3Desc: "The art of the elegant solution. We use our technical creativity to bypass complexity. Where others see constraints, we see opportunities to create lighter, smarter, and higher-performing systems.",
      // Timeline section
      timelineTitle: "Our Story",
      timeline1Year: "Summer 2025",
      timeline1Title: "The Spark",
      timeline1Desc: "Six students, one striking realization: our windows are the weak links in energy efficiency. The goal is born: tame the sun to combine comfort and savings, as part of the CQI challenge.",
      timeline2Year: "Fall 2025",
      timeline2Title: "From Idea to Prototype",
      timeline2Desc: "Sleepless nights, construction wood, and a first victory: our prototype. The proof is there: the technology works. Thermal intelligence becomes reality.",
      timeline3Year: "Winter 2026 - Today",
      timeline3Title: "The CQI Competition",
      timeline3Desc: "More than an academic step, the 'Innovative Design' challenge marks our pivot. We are no longer presenting just a student project, but a company vision ready to make a real impact.",
      timeline4Year: "Summer 2026",
      timeline4Title: "Towards Real Impact",
      timeline4Desc: "We are finalizing the design and product, preparing for deployment. Our mission truly begins: measuring the impact of our solution in real homes.",
      // Team section
      teamTitle: "The Team Behind the Vision",
      teamSubtitle: "Six complementary talents united by the same ambition: making energy efficiency accessible to all.",
      // Social section
      socialTitle: "Join the movement."
    },
    solutionPage: {
      // Intro Section
      introTitle1: "A Perfect",
      introTitle2: "Synergy",
      introSubtitle: "Our strategy rests on three interconnected pillars. Innovative hardware, piloted by an intuitive app, optimized by cutting-edge science.",
      nodeApi: "The API",
      nodeApiSub: "Scientific Brain",
      nodeApp: "The App",
      nodeAppSub: "Intuitive Control",
      nodeFilter: "The Filter",
      nodeFilterSub: "Physical Action",
      // Filter Section
      filterBadge: "Component 01",
      filterTitle1: "The Thermal Shield",
      filterTitle2: "Reversible & Non-Permanent",
      filterDesc: "An engineering feat that uses mechanical tension rather than glue. Install, flip, or remove your filter in seconds, without any tools or damage.",
      statUV: "UV Rays Blocked",
      statIR: "Infrared Rejected",
      statInstall: "Installation Time",
      reverseTitle: "\"Reverse\" Technology",
      reverseDesc: "Classic films are a compromise: they reject heat in summer but also in winter. Our solution innovates:",
      reverseSummer: "Side A (Summer): Maximum thermal rejection",
      reverseWinter: "Side B (Winter): Heat conservation",
      transparencyTitle: "Crystal Clear Transparency",
      transparencyDesc: "Why live in the dark to stay cool? Unlike blinds that obstruct the view, our filter preserves the connection with the outdoors.",
      visibility: "Visibility",
      comparisonTitle: "The Comparison Match",
      comparisonSubtitle: "Clear technical superiority on all points.",
      critere: "Criteria",
      sailectech: "SAILECtech",
      colStore: "Blinds",
      colFilm: "Film",
      colWindow: "Smart Window",
      compInstallation: "Installation",
      compInstallSailec: "5 min (Clips)",
      compInstallStore: "Manual / Complex",
      compInstallFilm: "Permanent (Glue)",
      compInstallWindow: "Major Renovation",
      compSeason: "Seasonality",
      compSeasonSailec: "Adaptable (Summer/Winter Mode)",
      compSeasonStore: "Fixed",
      compSeasonFilm: "Fixed (Winter Loss)",
      compSeasonWindow: "Adaptable",
      compCost: "Cost",
      compCostSailec: "Affordable & Quick ROI",
      compCostStore: "Low",
      compCostFilm: "Medium",
      compCostWindow: "Extreme ($$$)",
      compHeat: "Heat Management",
      compHeatSailec: "Exterior Rejection",
      compHeatStore: "Interior Absorption",
      compHeatFilm: "Partial Rejection",
      compHeatWindow: "Effective Rejection",
      compVisibility: "Visibility",
      compVisibilitySailec: "Clear & Preserved",
      compVisibilityStore: "Obstructed",
      compVisibilityFilm: "Permanent Tint",
      compVisibilityWindow: "Variable Tint",
      // App Section
      appBadge: "Component 02",
      appTitle: "The Command Center",
      appComingSoon: "Coming soon on App Store & Play Store",
      onboardingTitle: "1. Ultra-Fast Onboarding",
      step: "Step",
      config: "Configuration",
      step1Desc: "Local solar potential analysis.",
      step2Desc: "Digitization of your space.",
      step3Desc: "Creation of the thermal model.",
      step4Desc: "Layout verification.",
      step5Desc: "Your estimated energy gains.",
      dashboardTitle: "2. Showcase Your Impact",
      dashboardDesc: "Visualize your savings in real-time. See your impact in the way that matters most to you. An interface designed to be understood at a glance.",
      dashboardMain: "Main Dashboard",
      dashboardSub: "Savings & KPIs",
      zoneTitle: "3. Control per Room",
      zoneDesc: "A floor plan view allows you to manage each room individually. Bedroom too hot? Adjust it without leaving the living room.",
      zonePlan: "Plan View",
      zoneSub: "Per Room Management",
      // API Section
      apiBadge: "Component 03",
      apiTitle: "The Invisible Intelligence",
      apiDesc: "This is our major differentiator. Where other systems are simple \"on/off\", our API uses a proprietary thermal model.",
      apiInputTitle: "Incoming Data",
      apiInputDesc: "The API ingests local weather, window orientation, and your temperature preferences in real-time.",
      apiCalcTitle: "The Calculation",
      apiCalcDesc: "Our algorithm determines the exact filter position to maximize natural light while blocking excessive thermal gain.",
      apiAutoTitle: "Automation",
      apiAutoDesc: "The command is sent to the hardware without you having to intervene. That is true comfort: never having to think about it.",
      // Recap Section
      recapTitle: "Why does it change everything?",
      recap1Num: "01. App",
      recap1Title: "User Experience",
      recap1Desc: "Ease of use. We remove technological friction to keep only the control.",
      recap2Num: "02. API",
      recap2Title: "Scientific Rigor",
      recap2Desc: "Continuous optimization. A system that gets smarter with time and data.",
      recap3Num: "03. Filter",
      recap3Title: "Real Result",
      recap3Desc: "Physical efficiency. Tangible savings on the bill and immediate felt comfort."
    },
    waitlist: {
      title: "Join the Waitlist",
      subtitle: "Our smart filters are coming soon!",
      description: "We are currently finalizing the development of our smart filters. Sign up to be among the first to know about the launch and get an exclusive offer.",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone (optional)",
      windowSize: "Desired window size",
      small: "Small (60-100 cm)",
      medium: "Medium (100-150 cm)",
      large: "Large (150-220 cm)",
      xlarge: "Extra Large (220+ cm)",
      submitButton: "Join the waitlist",
      successTitle: "Registration successful!",
      successMessage: "Thank you for your interest. We will contact you as soon as we launch.",
      benefits: "Exclusive benefits",
      benefit1: "Priority access at launch",
      benefit2: "15% discount for early birds",
      limitedSpots: "Limited spots - Sign up now!",
      submitting: "Registering..."
    }
  }
}